import cx from 'classnames';
import { HTMLAttributes } from 'react';

import s from './editorContainer.module.scss';

type Props = HTMLAttributes<HTMLDivElement>;

export const EditorContainer = ({
  className,
  children,
  ...props
}: Props): JSX.Element => (
  <div
    className={cx(s.editorContainer, className)}
    {...props}
    data-color-mode="light"
  >
    <div className={s.editorContent}>{children}</div>
  </div>
);
